import { createUseStyles } from "react-jss";

interface Props {
  weekNumber?: boolean,
};

const useStyles = createUseStyles((theme: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%', 
    '& > label': {
      display: 'flex',
      color: theme.colors.black,
      fontSize: '14px',
      marginTop: '16px',
      marginBottom: '7px',
      fontWeight: 'bold',
      width: '100%',
    },
  },
  inputs: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  datePickerInput: {
    position: "relative",
    borderRadius: "12px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    minWidth: '120px',
    maxWidth: 'calc(100% - 27px)',
    height: "34px",
    backgroundColor: theme.colors.white,
    padding: "0px 15px 0px 15px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: theme.colors.grey[325],
    '&:hover': {
      cursor: "pointer",
    },
    '&.disabled': {
      cursor: 'auto',
      backgroundColor: theme.colors.grey[75],
      color: theme.colors.grey[560],
      '& svg': {
        color: theme.colors.grey[560],
      },
    },
  },
  timePickerInput: {
    position: "relative",
    borderRadius: "12px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    minWidth: '20px',
    maxWidth: 'calc(100% - 27px)',
    height: "34px",
    backgroundColor: theme.colors.white,
    padding: "0px 15px 0px 15px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: theme.colors.grey[325],
    '& > div': {
      fontSize: '14px',
      lineHeight: 'unset',
      height: '100%',
      padding: '0',
      '& > input': {
        padding: '0',
        border: '0',
        height: '100%',
        width: '50px',
      },
      '& > fieldset': {
        border: '0',
      },
    },
    '&:hover': {
      cursor: "pointer",
    },
    '&.disabled': {
      cursor: 'auto',
      backgroundColor: theme.colors.grey[75],
      color: theme.colors.grey[560],
      '& svg': {
        color: theme.colors.grey[560],
      },
    },
  },
  selectedDate: {
    marginBottom: '0 !important',
    fontSize: '14px',
    cursor: "pointer"
  },
  calendarWrapper: {
    '& .MuiPopover-paper': {
      borderRadius: '10px',
      boxShadow: theme.shadows[2],
    },
  },
  calendar: {
    position: "relative",
    width: (props: Props) => props.weekNumber ? "320px" : "280px",
    maxHeight: "500px",
    maxWidth: '100%',
    backgroundColor: theme.colors.white,
    zIndex: "9999",
    display: "flex",
    flexWrap: "wrap",
    borderRadius: '10px',
    boxShadow: "0px 3px 20px rgba(0,0,0,0.08)",
    overflow: 'hidden',
  },
  calendarHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '5px 20px',
    '& p': {
      marginBottom: '0',
      fontWeight: 'bold',
    }
  },
  weekdayHeader: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#ececec',
    cursor: 'auto',
  },
  weekday: {
    width: 'calc(100% / 7)',
    padding: '5px 0',
    fontSize: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      width: '100%',
      textAlign: 'center',
      marginBottom: '0 !important',
      fontSize: '11px !important',
    },
  },
  dateWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  navigator: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '68px',
    '& svg': {
      color: theme.colors.primaryBlue[500],
      width: '20px',
      height: '20px',
    },
  },
  close: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: 'center',
    '& > svg': {
      color: theme.colors.primaryBlue[500],
      width: "16px",
      height: "16px",
    },
  },
  timePicker: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    borderTopWidth: '0.125rem',
    borderTopStyle: 'solid',
    borderTopColor: theme.colors.grey[300],
    maxWidth: '100%',
    '& > input': {
      flex: '1 1 50%',
      width: '100%',
      border: '0',
      outline: 'none',
      '-webkit-appearance': 'none',
      padding: '0.25rem 0.5rem',
    },
  },
  timepickerPaper: {
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadows[2],
    borderRadius: '6px',
    '& .MuiMultiSectionDigitalClock-root': {
      borderBottom: '0',
      '& .MuiMultiSectionDigitalClockSection-root': {
        '&::after': {
          display: 'none',
        },
      },
    },
  },
  timepickerItem: {
    backgroundColor: theme.colors.grey[300],
    borderRadius: '12px',
    fontSize: '16px',
    '&.Mui-selected': {
      backgroundColor: theme.colors.primaryBlue[500],
    },
  },
  timepickerClockButton: {
    '& > svg': {
      width: '16px',
      height: '16px',
    },
  },
}));

export default useStyles;